import { render, staticRenderFns } from "./AddCandidate.vue?vue&type=template&id=51f48f18"
import script from "./AddCandidate.vue?vue&type=script&lang=js"
export * from "./AddCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports